import {
  checkPATTokenOnURL,
  DealerApiCommunications,
  performInitialLoginAttempt,
  refreshUserToken,
  startTokenRefreshTimer
} from '../../webmodule-common/other/api/dealer-api-communications';
import { getCurrentUser } from '../../webmodule-common/other/api/current-user';
import { information } from '../../webmodule-common/other/ui/modal-option';
import { isCynclyStaff } from '../../webmodule-common/other/currentuser-claims';
import { tlang } from '../../webmodule-common/other/language/lang';
import { userDataStore } from '../supplier/common/current-user-data-store';

export async function performPageLoadLoginVerifications(updateNote: (message: string) => void) {
  // if we resolved a PAT token, then we just force switched authentication and can exit
  if (await checkPATTokenOnURL()) return true;

  //This is going to go to the api and verify the user token is valid
  //and if it is, it will also set the security roles of the user
  const valid = await DealerApiCommunications.verifyUserAndSetSecurityClaims('api/LicenseServer/verifyuser');
  if (!valid) {
    await performInitialLoginAttempt('api/LicenseServer/verifyuser');
    return getCurrentUser() !== null;
  } else {
    const user = await refreshUserToken(updateNote);
    if (user) {
      updateNote('Fetching User Settings');
      await userDataStore.loadCoreDetails();
      const usingPAT = localStorage.getItem('PAT-in-use') !== null;
      if (usingPAT) {
        const title = (user as any).tenantName ? `${(user as any).tenantName}` : tlang`Support Access Granted`;
        if (!isCynclyStaff())
          await information(
            tlang`You are accessing this system using a temporary access login. please logoff if this is unintentional`,
            title
          );
      } else {
        startTokenRefreshTimer();
      }
      return true;
    } else return false;
  }
}

export async function dealerVerifyUser(updateNote: (message: string) => void) {
  return await performPageLoadLoginVerifications(updateNote);
}
